let end_form_captcha_id,
  newsletter_captcha_id;

const captcha_sitekey = process.env.CAPTCHA_SITEKEY_CHECKBOX,
  captcha_sitekey2 = process.env.CAPTCHA_SITEKEY_INVISIBLE,
  websiteContactApiUrl = process.env.WEBSITE_CONTACT_API_URL;
import intlTelInput from 'intl-tel-input';
import * as  public_email_domains from "~/static/resources/json/free_email_provider_domains.json";

//

function get_prevsite() {
  const urlParams = new URLSearchParams(window.location.search);
  let source = urlParams.get('utm_source');
  let medium = urlParams.get('utm_medium');

  // Verifica sessionStorage para el referente original
  let ref = sessionStorage.getItem('original_ref');
  if (!ref) {
    // Si no se almacena ningún referente original, utiliza document.referrer o 'direct traffic' 
    ref = document.referrer || 'direct traffic';
    sessionStorage.setItem('original_ref', ref);
  }

  // Verifica sessionStorage para el sitio anterior
  let prevsite = sessionStorage.getItem('prevsite');

  // Almacena el document.referrer actual como el sitio anterior para la próxima visita
  sessionStorage.setItem('prevsite', document.referrer || 'direct traffic');

  return { ref, prevsite, source, medium };
}

//

function field_success(e) {
  let r = e.attr("id");
  $(e).addClass("success");
  $("#error-" + r).remove();
}
window.controls_fields = function (e, r) {
  let t = e.attr("id"),
    a = e.attr("data-placement"),
    o = $("#spanish").hasClass("active"),
    i = $(".right").hasClass("active"),
    val = $(e).val(),
    req = $(e).attr("data-required") === "true",
    hasVal = val != null && val !== ""
  if (req && !hasVal) {
    let id = $(e).attr("id"),
      r = $("#spanish").hasClass("active"),
      t = $(".right").hasClass("active");
    $(e).addClass("error");
    return (r || t
      ? $(".input-group-" + id).append(
        "<p id='error-" + id + "' class='error-field'>Campo obligatorio</p>"
      )
      : $(".input-group-" + id).append(
        "<p id='error-" + id + "' class='error-field'>Obligatory field</p>"
      ),
      $("#error-" + id).next(),
      !1
    )
  }
  if (hasVal) {
    switch (t) {
      case "fullname":
      case "firstname":
      case "lastname":
      case "chk-service-other":
      case "chk-platform-other":
        return !(
          !field_length(e, 3, 100) ||
          !only_letters(e) ||
          (field_success(e), 0)
        );
      case "age":
      case "genre":
      case "experience":
        return !(
          (field_success(e), 0)
        );
      case "organization":
      case "role":
        return !(
          !field_length(e, 3, 100) ||
          !only_numbers(e) ||
          (field_success(e), 0)
        );
      case "email":
        return !(
          !validate_email(e) ||
          //  !validate_domain_email(e) ||
          (field_success(e), 0)
        );
      case "email-careers":
        return !(
          !field_length(e, 3, 100) ||
          !validate_email(e) ||
          (field_success(e), 0)
        );
      case "phone":
        return (
          !field_length(e, 5, 20) ||
          !validate_phone(e) ||
          (field_success(e), !0)
        );
      case "message":
        return !(
          !field_length(e, 15, 1e3) ||
          !only_numbers(e) ||
          (field_success(e), 0)
        );
      case "field_34":
        return (
          !!e.is(":checked") ||
          (o || i
            ? $("#label_field_34").after(
              "<p id='error-" +
              t +
              "' class='error-field'>Para continuar, por favor acepte la politica de privacidad.</p>"
            )
            : $("#label_field_34").after(
              "<p id='error-" +
              t +
              "' class='error-field'>To continue, please accept the privacy policy.</p>"
            ),
            !1)
        );
      case "country":
        return !(
          (field_success(e), 0)
        );
      default:
        return (field_success(e), 0)
    }
  }
  return true;
}
function field_length(e, r, t) {
  let a = e.val().length,
    o = e.attr("data-placement"),
    i = e.attr("id"),
    s = $("#spanish").hasClass("active"),
    n = $(".right").hasClass("active");
  if (a < r) {
    if (
      ($(e).addClass("error"),
        s || n)
    ) {
      let t = e.attr("data-type");
      $(".input-group-" + i).append(
        "<p id='error-" +
        i +
        "' class='error-field'>" +
        t +
        " debe contener un mínimo de " +
        r +
        " caracteres</p>"
      );
    } else
      $(".input-group-" + i).append(
        "<p id='error-" +
        i +
        "' class='error-field'>" +
        o +
        " needs to be at least " +
        r +
        " characters to be sent.</p>"
      );
    return !1;
  }
  if (a > t) {
    if (
      ($(e).addClass("error"),
        s || n)
    ) {
      let r = e.attr("data-type");
      $(".input-group-" + i).append(
        "<p id='error-" +
        i +
        "' class='error-field'>" +
        r +
        " debe contener un máximo de " +
        t +
        " caracteres.</p>"
      );
    } else
      $(".input-group-" + i).append(
        "<p id='error-" +
        i +
        "' class='error-field'>" +
        o +
        " needs to be less than " +
        t +
        " characters.</p>"
      );
    return !1;
  }
  return !0;
}
function only_letters(e) {
  let r = e.attr("id"),
    t = e.attr("data-placement"),
    a = $("#spanish").hasClass("active"),
    o = $(".right").hasClass("active");
  if (/^[a-zA-ZÀ-ÿ ]*$/.test(e.val())) return !0;
  if (
    ($(e).addClass("error"),
      a || o)
  ) {
    let t = e.attr("data-type");
    $(".input-group-" + r).append(
      "<p id='error-" +
      r +
      "' class='error-field'>" +
      t +
      " debe contener solo letras.</p>"
    );
  } else
    $(".input-group-" + r).append(
      "<p id='error-" +
      r +
      "' class='error-field'>" +
      t +
      " needs contain only letters.</p>"
    );
  return !1;
}
function only_numbers(e) {
  let r = e.attr("id"),
    t = e.attr("data-placement"),
    a = $("#spanish").hasClass("active"),
    o = $(".right").hasClass("active");
  if (/^[0-9]+$/.test(e.val())) {
    if (
      ($(e).addClass("error"),
        a || o)
    ) {
      let t = e.attr("data-type");
      $(".input-group-" + r).append(
        "<p id='error-" +
        r +
        "' class='error-field'>" +
        t +
        " debe contener letras.</p>"
      );
    } else
      $(".input-group-" + r).append(
        "<p id='error-" +
        r +
        "' class='error-field'>" +
        t +
        " needs to contain letters.</p>"
      );
    return !1;
  }
  return !0;
}


/*
function validate_phone(e) {
  let r = e.attr("id"),
    t = e.attr("data-placement"),
    a = $("#spanish").hasClass("active"),
    o = $(".right").hasClass("active");
  if (/^[+0-9\s-]+$/.test(e.val())) return !0;
  if (
    ($(e).addClass("error"),
      a || o)
  ) {
    let t = e.attr("data-type");
    $(".input-group-" + r).append(
      "<p id='error-" +
      r +
      "' class='error-field'>" +
      t +
      " debe contener solo números.</p>"
    );
  } else
    $(".input-group-" + r).append(
      "<p id='error-" +
      r +
      "' class='error-field'>" +
      t +
      " needs to contain only numbers.</p>"
    );
  return !1;
} */

function validate_phone(e) {
  let o = e.attr("id"),
    r = e.attr("data-placement");
  let isValid = true;
  let errorMessage = "";
  const intTelInstance = window.intlTelInputGlobals.getInstance(e[0]);
  if (intTelInstance) {
    const countryData = intTelInstance.getSelectedCountryData();
    if (!countryData && !countryData.dial) {
      isValid = false;
      errorMessage = "Please select your country’s phone prefix."
    }
  }
  //  isValid = /^[+0-9\s-]+$/.test(e.val());
  isValid = /^[0-9]+$/.test(e.val());
  errorMessage = `${r} must contain only numbers.`;
  return isValid
    ? (field_success(e), !0)
    : ($(e).addClass("error"),
      $(".input-group-" + o).append(
        `<p id='error-${o}' class='error-field'>${errorMessage}</p>`
      ),
      !1);
}

function validate_email(e) {
  let r = e.val().toLowerCase().trim(),
    t = e.attr("id"),
    a = $("#spanish").hasClass("active"),
    o = $(".right").hasClass("active"),
    isValid = !!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(r),
    errorMsg = a || o ? "Tu correo es inválido. Por favor, verifique que esté bien escrito." :
      "Your email seems invalid. Please check it is typed correctly."
  if (!isValid) {
    $(e).addClass("error");
    if (r.indexOf("@") == -1) {
      errorMsg = a || o ? "El correo es inválido. No se encontro el caracter \"@\"." :
        "Your email seems invalid. Missing \"@\" character."
    }
    $(".input-group-" + t).append(
      `<p id='error-${t}' class='error-field'>${errorMsg}</p>`
    )
    return false;
  }
  return true;
}
$(".error-pdf").hide(),
  $(document).ready(function () {
    $(".loading_animation").hide(),
      $(".form-thank-you").hide(),
      $(".w3-light-grey").hide(),
      $(".error-form").hide(),
      $(".input-file-progress-bar").hide(),
      $(".error-email-form").hide()
  }),
  $(document).on("keypress", "input", function () {
    let e = $(this).val().replace(/\s+/g, " ");
    $(this).val(e);
  }),
  $(document).on("focus", "input", function () {
    let e = $(this).attr("id");
    $("#error-" + e).remove();
    $(this).removeClass("error");
    $(this).removeClass("success");
  }),
  $(document).on("focus", "textarea", function () {
    let e = $(this).attr("id");
    $("#error-" + e).remove();
    $(this).removeClass("error");
    $(this).removeClass("success");
  }),
  $(document).on("blur", "input", function () {
    let e = $(".form_contact").attr("id");
    return controls_fields($(this), e), !0;
  }),
  $(document).on("blur", "textarea", function () {
    controls_fields($(this))
  }),
  $(document).on("change", "select", function () {
    let e = $(this).attr("id");
    $("#error-" + e).remove();
    $(this).removeClass("error");
    $(this).removeClass("success");
    controls_fields($(this))
  }),
  $(document).on("change", "#field_34", function () {
    $("#error-field_34").remove();
  });

function validate_domain_email(e) {
  let r = e.val(),
    t = e.attr("id");
  var a = r.substr(r.lastIndexOf("@") + 1, r.length - 1);
  return (
    (a = a.toLowerCase()),
    -1 === public_email_domains.indexOf(a) ||
    ($(e).addClass("error"),
      $(".input-group-" + t).append(
        "<p id='error-" +
        t +
        "' class='error-field'>Sorry, please use your corporate email address.</p>"
      ),
      !1)
  );
}
function move() {
  var e = document.getElementById("myBar"),
    r = 0,
    t = setInterval(function () {
      r >= 100 ? clearInterval(t) : (r++, (e.style.width = r + "%"));
    }, 0);
}
function move_size(e) {
  let r,
    t = Math.round(e / 1048576);
  t < 1 && (r = Math.round(e / 1024)),
    r
      ? ((e = r), $(".size-pdf").html(r + " KB"))
      : ($(".size-pdf").html(t + " MB"), (e = t));
  let a = 0,
    o = setInterval(function () {
      a > e ? clearInterval(o) : $(".size-upload").html(a++);
    }, 10);
}
window.closeUploadPdf = function () {
  $("#cv-upload").val(""),
    $(".input-file-progress-bar").hide(),
    $(".label-input").show(),
    $(".input-file-inner").removeClass("success error");
}
window.control_submit_form = function (event) {
  event.preventDefault();
  let e = $("#fullname"),
    r = $("#organization"),
    a = $("#email"),
    o = $("#message"),
    i = $("#phone"),
    s = $("#field_34"),
    country = $("#country"),
    form = $("form[name=main-form]"),
    n = !0;
  $(form).find(".error-field").remove();
  if (!grecaptcha.getResponse(end_form_captcha_id)) {
    $("#end_form_captcha").after(
      "<p id='error-captcha' class='error-field'>The captcha is missing or wrong.</p>"
    );
    n = !1;
  }
  controls_fields(e) || (n = !1),
    controls_fields(r) || (n = !1),
    controls_fields(a) || (n = !1),
    controls_fields(o) || (n = !1),
    controls_fields(i) || (n = !1),
    controls_fields(s) || (n = !1),
    controls_fields(country) || (n = !1),
    n && submit_main_form();
}
function submit_main_form() {
  let e = $("#fullname"),
    r = $("#organization"),
    a = $("#email"),
    phone = $("#phone"),
    phoneInstance = window.intlTelInputGlobals.getInstance(phone[0]),
    //o = $("#phone"),
    i = $("#message"),
    country = $("#country"),
    s = $("form[name=main-form]"),
    ref = "",
    prevsite = "",
    c = grecaptcha.getResponse(end_form_captcha_id),
    d = "",
    /*
    gdprVal34 = "",
    */
    url = "",
    device = "",
    formId = "";
  (d = $(s).attr("data-link")),
    /*
    (gdprVal34 = $("#field_34").val()),
    get_ref() && (n = get_ref()),
    get_prevsite() && (l = get_prevsite()),
    */
    (formId = s.attr("id")),
    (url = window.location.href),
    (device = get_device_type());

  //
  let referrerData = get_prevsite();
  ref = referrerData.ref;
  prevsite = referrerData.prevsite;
  let source = referrerData.source || "";
  let medium = referrerData.medium || "";
  let gdprVal34 = $("#field_34").prop("checked");
  let suscription = $("#field_suscription").prop("checked");
  //

  let phoneNumber = phone.val();
  if (phoneInstance && phoneInstance.getSelectedCountryData())
    phoneNumber = `+${phoneInstance.getSelectedCountryData().dialCode}${phone.val()}`;
  let p = {
    name: e.val(),
    company: r.val(),
    email: a.val().toLowerCase().trim(),
    comments: i.val(),
    //phone: o.val(),
    phone: phoneNumber,
    country: country.val(),
    form: "14",
    url: url,
    ref: ref,
    prevsite: prevsite,
    device: device,
    //
    source: source,
    medium: medium,
    suscription: suscription,
    //
    captcharesponse: c,
    gdpr2019: gdprVal34,
  };

  $.ajax({
    type: "POST",
    url: `${websiteContactApiUrl}/activecampaign-add-update-contact`,
    data: JSON.stringify(p),
    contentType: "application/json",
    beforeSend: function () {
      $(".btn-contact").addClass("loading")
    },
    success: function (e) {
      if (e.errorMessage) {
        $(s).find('.btn-contact').removeClass("loading");
        $(s).find('.div-submit').append("<p class='error-field error-field-large'>There was an error, please try again.</p>")
      }
      else {
        $(s)[0].reset();
        window.location.href = d;
      }
    },
    error: function (e) {
      $(s).find('.btn-contact').removeClass("loading");
      $(s).find('.div-submit').append("<p class='error-field error-field-large'>There was an error, please try again.</p>")
    },
  });
}

window.end_page_form = function (event) {
  event.preventDefault();
  var e = !0;
  $(".error-field").remove(), $("#error-captcha").remove();
  var r = $("#fullname"),
    t = $("#email-careers"),
    y = $("#country"),
    a = $("#role"),
    //o = $("#phone"),
    phone = $("#phone"),
    phoneInstance = window.intlTelInputGlobals.getInstance(phone[0]),
    m = $("#message"),
    i = $("#field_34"),
    s = $("#cv-upload")[0].files[0],
    n = "",
    successPage = $("form[name='main-form']").attr("data-link");
  let l = grecaptcha.getResponse(end_form_captcha_id);
  let c = $("#spanish").hasClass("active"),
    d = $(".right").hasClass("active");
  //
  let referrerData = get_prevsite();
  let ref = referrerData.ref;
  let prevsite = referrerData.prevsite;
  let source = referrerData.source || "";
  let medium = referrerData.medium || "";
  let gdprVal34 = $("#field_34").prop("checked");
  let suscription = $("#field_suscription").prop("checked");
  //

  if (
    (controls_fields(r) || (e = !1),
      controls_fields(t) || (e = !1),
      controls_fields(y) || (e = !1),
      controls_fields(a) || (e = !1),
      controls_fields(phone) || (e = !1),
      //controls_fields(o) || (e = !1),
      controls_fields(i) || (e = !1),
      controls_fields(m) || (e = !1),
      /*
      get_ref() && (s = get_ref()),
      get_prevsite() && (n = get_prevsite()),
      */
      l ||
      (c || d
        ? $("#end_form_captcha").after(
          "<p id='error-captcha' class='error-field'>El captcha esta vacio o incompleto</p>"
        )
        : $("#end_form_captcha").after(
          "<p id='error-captcha' class='error-field'>The captcha is missing or wrong.</p>"
        ),
        (e = !1)),
      s)
  ) {
    let e = $("#cv-upload")[0].files[0].size;
    (e /= 1048576) &&
      e > 10 &&
      ($(".error-pdf").html("The file you are trying to upload exceeds 10MB").show(),
        $(".input-file-inner").addClass("error"));
  }
  if (e) {
    const p = window.location.href,
      f = get_device_type();
    let phoneNumber = phone.val();
    if (phoneInstance && phoneInstance.getSelectedCountryData())
      phoneNumber = `+${phoneInstance.getSelectedCountryData().dialCode}${phone.val()}`;

    /*ref = get_ref();*/
    const fullName = r.val();
    const desiredPosition = a.val()
    //const phone = o.val();
    const email = t.val().toLowerCase().trim();
    const country = y.val();
    const comments = m.val();
    const cvFile = $("#cv-upload")[0].files[0];

    var acUserData = {
      name: fullName,
      desiredposition: desiredPosition,
      email,
      country,
      phone: phoneNumber,
      comments,
      form: "34",
      url: p,
      ref: ref,
      prevsite: prevsite,
      device: f,
      //
      source: source,
      medium: medium,
      suscription: suscription,
      //
      captcharesponse: l,
      gdpr2019: gdprVal34,
    };

    $(".btn-contact").addClass("loading");
    contactCareers({ fullName, desiredPosition, email, country, phone: phoneNumber, cvFile, contactUrl: p, captchaResponse: l, acUserData })
      .then((() => {
        $(s).find('.btn-contact').removeClass("loading");
        $(".form_contact")[0].reset();
        window.location.href = successPage;
      })).catch((e) => {
        $(s).find('.btn-contact').removeClass("loading");
        $(s).find('.div-submit').append("<p class='error-field error-field-large'>There was an error, please try again.</p>")
      })
  }
}


async function uploadCV(cvFile) {
  const { uploadURL, fileName } = await getUploadUrlCV();
  return new Promise((resolve, reject) => {
    $.ajax({
      url: uploadURL,
      method: "PUT",
      contentType: "application/pdf",
      data: cvFile,
      processData: false,
      success: () => {
        resolve(fileName);
      },
      error: reject,
    });
  })
}

function getUploadUrlCV() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${websiteContactApiUrl}/get-upload-url/cv`,
      success: resolve,
      error: reject,
    });
  })
}

function contactCareers({ fullName, desiredPosition, email, country, phone, cvFile, contactUrl, captchaResponse, acUserData }) {
  return new Promise((resolve, reject) => {
    uploadCV(cvFile).then(uploadedFileName => {
      const data = {
        fullName, desiredPosition, email, country, phone,
        cvPath: uploadedFileName, contactUrl,
        captchaResponse, acUserData
      };
      $.ajax({
        url: `${websiteContactApiUrl}/careers-send-email`,
        method: "POST",
        data: JSON.stringify(data),
        success: resolve,
        error: reject
      });
    })
  })
}

//

function initPhoneInput() {
  const telInput = document.querySelector("#phone");
  if (telInput) {
    intlTelInput(telInput, {
      separateDialCode: true,
      nationalMode: false,
      autoHideDialCode: false,
      initialCountry: "auto",
      geoIpLookup: function (success, failure) {
        $.get("https://ipinfo.io", function () { }, "jsonp").always(function (resp) {
          var countryCode = (resp && resp.country) ? resp.country : "us";
          success(countryCode);
        });
      }
    });
  }
  telInput.addEventListener("open:countrydropdown", () => { telInput.closest(".input-text").classList.add("focus") });
  telInput.addEventListener("focus", () => { telInput.closest(".input-text").classList.add("focus") });
  telInput.addEventListener("blur", () => {
    if (document.querySelector("#phone").value) {
      telInput.closest(".input-text").classList.remove("focus");
      telInput.closest(".input-text").classList.add("error");
      telInput.closest("#phone").classList.contains('success') ? telInput.closest(".input-text").classList.add("success") : telInput.closest(".input-text").classList.remove("success");
    } else {
      telInput.closest(".input-text").classList.remove("focus");
      telInput.closest(".input-text").classList.remove("error");
      telInput.closest(".input-text").classList.remove("success");
    }
  });
}

function initCountryInput() {
  const countryInput = document.querySelector("#country");
  countryInput.closest(".input-text").classList.add("focus");
  if (countryInput) {
    const countryInputIti = intlTelInput(countryInput, {
      nationalMode: true,
      autoHideDialCode: true,
      initialCountry: "auto",
      geoIpLookup: function (success, failure) {
        $.get("https://ipinfo.io", function () { }, "jsonp").always(function (resp) {
          var countryCode = (resp && resp.country) ? resp.country : "us";
          success(countryCode);
        });
      },
    });
    const setCountry = () => {
      const countryData = countryInputIti.getSelectedCountryData();
      countryInput.value = countryData.name || "";
      controls_fields($(countryInput));
      const container = countryInput.closest(".input-text");
      container.classList.remove("focus");
      if (countryInput.value) container.classList.add("valid", "success");
      else container.classList.remove("valid", "success");
    }
    countryInput.addEventListener("countrychange", setCountry);
    countryInput.addEventListener("open:countrydropdown", () => { const container = countryInput.closest(".input-text").classList.add("focus") });
    countryInput.addEventListener("close:countrydropdown", setCountry);
    countryInput.addEventListener("blur", (e) => {
      setCountry();
    });
    countryInput.addEventListener("keydown", (e) => {
      e.preventDefault();
      return false
    });
    countryInput.addEventListener("focus", (e) => {
      countryInput.closest(".input-text").classList.add("focus");
      document.activeElement.blur()
    });
    countryInput.addEventListener("click", function (e) {
      e.preventDefault();
      countryInput.closest(".iti").querySelector(".iti__selected-flag").dispatchEvent(new Event("click"));
      return false;
    })
  }
}

//

window.control_form_download = function (e) {
  console.log("entre");
  e.preventDefault();
  $(".error-field").remove();
  var e = $("#fullname"),
    t = $("#organization"),
    a = $("#email"),
    o = $("#role"),
    //
    p = $("#experience"),
    r = $("#genre"),
    q = $("#age"),
    //

    i = $("#field_34");
  let res = !0
  console.log("antes del if");
  if (!grecaptcha.getResponse(window.end_form_captcha_id)) {
    $("#end_form_captcha").after(
      "<p id='error-captcha' class='error-field'>The captcha is missing or wrong.</p>"
    );
    res = !1;
  }
  console.log("despues del if");
  controls_fields(e) || (res = !1),
    controls_fields(t) || (res = !1),
    controls_fields(o) || (res = !1),
    controls_fields(p) || (res = !1),
    controls_fields(r) || (res = !1),
    controls_fields(q) || (res = !1),
    controls_fields(a, "103") || (res = !1),
    controls_fields(i) || (res = !1),
    res && submit_main_form_download();
  console.log(res)
}
window.control_form_google_ads = function () {
  $(".error-field").remove(), $("#error-captcha").remove();
  let e = $("#firstname"),
    r = $("#email"),
    t = $("#phone");
  var a = grecaptcha.getResponse(end_form_captcha_id);
  let o = !0;
  controls_fields(e) || (o = !1),
    controls_fields(r) || (o = !1),
    controls_fields(t) || (o = !1),
    a ||
    ($("#end_form_captcha").after(
      "<p id='error-captcha' class='error-field'>The captcha is missing or wrong.</p>"
    ),
      (o = !1)),
    o && submit_main_form_google();
}
function submit_main_form_download() {
  console.log("Dentro de submit")
  let e = $("#fullname"),
    t = $("#organization"),
    a = $("#role"),
    o = $("#email"),
    p = $("#experience"),
    r = $("#genre"),
    q = $("#age"),
    i = $("form[name=main-form]"),
    s = "",
    ref = "",
    prevsite = "",
    /*gdprVal34 = "",*/
    url = "",
    device = "",
    l = $(i).attr("data-link"),
    captcha = grecaptcha.getResponse(window.end_form_captcha_id);
  console.log(e);
  /*(gdprVal34 = $("#field_34").val()),
    get_ref() && (s = get_ref()),
    get_prevsite() && (n = get_prevsite()),*/
  (i = i.attr("id")),
    (url = window.location.href),
    (device = get_device_type());
  //
  let referrerData = get_prevsite();
  ref = referrerData.ref;
  prevsite = referrerData.prevsite;
  let source = referrerData.source || "";
  let medium = referrerData.medium || "";
  let gdprVal34 = $("#field_34").prop("checked");
  let suscription = $("#field_suscription").prop("checked");
  //
  let c = {
    name: e.val(),
    jobtitle: a.val(),
    company: t.val(),
    email: o.val().toLowerCase().trim(),
    experience: p.val(),
    genre: r.val(),
    age: q.val(),
    form: i,
    url: url,
    ref: ref,
    prevsite: prevsite,
    device: device,
    //
    source: source,
    medium: medium,
    suscription: suscription,
    //
    desiredposition: "",
    gdpr2019: gdprVal34,
    captcharesponse: captcha
  };
  console.log(c);
  $.ajax({
    type: "POST",
    url: `${websiteContactApiUrl}/activecampaign-add-update-contact`,
    data: JSON.stringify(c),
    contentType: "application/json",
    beforeSend: function () {
      $(".btn-contact").addClass("loading");
    },
    success: function (e) {
      if (e.errorMessage) {
        $(s).find('.btn-contact').removeClass("loading");
        $(s).find('.div-submit').append("<p class='error-field error-field-large'>There was an error, please try again.</p>")
      }
      else {
        $("#" + i)[0].reset()
        window.location.href = l
      }
    },
    error: function (e) { },
  });
}
function submit_main_form_google() {
  let e = $("#firstname"),
    r = $("#email"),
    t = $("form[name=main-form]"),
    a = $(t).attr("data-link") + "success-contact-us",
    o = "",
    i = "",
    gdprVal34 = "",
    url = "",
    device = "";
  (gdprVal34 = $("#field_34").val()),
    get_ref() && (o = get_ref()),
    get_prevsite() && (i = get_prevsite()),
    (t = t.attr("id")),
    (url = window.location.href),
    (device = get_device_type());
  let s = {
    firstname: e.val(),
    email: r.val().toLowerCase().trim(),
    form: t,
    url: url,
    ref: o,
    prevsite: i,
    device: device,
    desiredposition: "",
    gdpr2019: gdprVal34,
  };
  $.ajax({
    type: "POST",
    url: `${websiteContactApiUrl}/add-contact-to-form`,
    data: JSON.stringify(s),
    contentType: "application/json",
    beforeSend: function () {
      $(".btn-contact").hide(),
        $(".h5cicd").remove(),
        $(".w3-light-grey").show(),
        progress_bar_form();
    },
    success: function (e) {
      e.errorMessage ||
        ($(".w3-light-grey").hide(),
          $("#" + t)[0].reset(),
          (window.location.href = a));
    },
    error: function (e) { },
  });
}
window.get_device_type = function () {
  return navigator.userAgent.match(/Tablet|iPad|iPod|Android/i) &&
    window.innerWidth <= 1280 &&
    window.innerHeight <= 800 &&
    !navigator.userAgent.match(/Mobile/i)
    ? "Tablet"
    : navigator.userAgent.match(
      /Android|BlackBerry|Tablet|Mobile|iPhone|iPad|iPod|Opera Mini|IEMobile/i
    )
      ? "Mobile"
      : "Computer";
}
window.newsletter_forms = async function (event) {
  event.preventDefault();
  let r = $("#email-nl"),
    form = $(".footer-container ._form");
  form.find("._form-error").hide();
  form.find("input").removeClass("error success");
  form.find(".error-field").html("");
  form.find(".error-field").hide();
  if (r.val()) {
    validate_email(r)
      ? (r.addClass("success"),
        grecaptcha.execute(newsletter_captcha_id))
      : (r.addClass("error"),
        r.parent()
          .find(".error-field")
          .html("The email seems invalid. Please check it's correctly typed."),
        r.parent().find(".error-field").show())
  }
  else {
    r.addClass("error"),
      r.parent().find(".error-field").html("Obligatory field."),
      r.parent().find(".error-field").show()
  }
}

function submit_newsletter_form() {
  let r = $("#email-nl"),
    t = "",
    a = "",
    o = $("#40").attr("data-link"),
    successurl = "";
  let form = $(".footer-container ._form");
  (successurl = o);
  /*  get_ref() && (t = get_ref()),
    get_prevsite() && (a = get_prevsite());*/
  //
  let referrerData = get_prevsite();
  ref = referrerData.ref;
  prevsite = referrerData.prevsite;
  let source = referrerData.source || "";
  let medium = referrerData.medium || "";
  //
  const userData = {
    email: r.val().toLowerCase().trim(),
    form: "40",
    url: window.location.href,
    ref: ref,
    prevsite: prevsite,
    device: get_device_type(),
    source: source,
    medium: medium,
    captcharesponse: grecaptcha.getResponse(newsletter_captcha_id),
  };
  let btnSubmit = $(form).find("button[type=\"submit\"]");
  $.ajax({
    type: "POST",
    url: `${websiteContactApiUrl}/activecampaign-add-update-contact`,
    data: JSON.stringify(userData),
    contentType: "application/json",
    beforeSend: function () {
      btnSubmit.addClass("loading");
    },
    success: function (e) {
      form[0].reset();
      window.location.href = successurl;
    },
    error: function (e) {
      btnSubmit.removeClass("loading");
      form.find("._form-error").html(
        "There was an error, please try again."
      );
      form.find("._form-error").show();
      //grecaptcha.reset(window.newsletter_captcha_id);
    },
  });
}
function set_adwords_variables() {
  var e = get_ref_parameter();
  e || (e = ""), window.sessionStorage.setItem("ref", e);
  var r = document.referrer;
  get_prevsite() ||
    (r || (r = "direct traffic"), window.sessionStorage.setItem("prevsite", r));
}
window.get_prevsite = function () {
  return window.sessionStorage.getItem("prevsite");
}
function get_ref_parameter() {
  return getParameterByName("ref", "");
}
window.get_ref = function () {
  return window.sessionStorage.getItem("ref");
}
function createCookie(e, r, t) {
  var a = "";
  if (t) {
    var o = new Date();
    o.setTime(o.getTime() + 24 * t * 60 * 60 * 1e3),
      (a = "; expires=" + o.toUTCString());
  }
  document.cookie = e + "=" + r + a + "; path=/";
}
function readCookie(e) {
  for (
    var r = e + "=", t = document.cookie.split(";"), a = 0;
    a < t.length;
    a++
  ) {
    for (var o = t[a]; " " == o.charAt(0);) o = o.substring(1, o.length);
    if (0 == o.indexOf(r)) return o.substring(r.length, o.length);
  }
  return null;
}
function eraseCookie(e) {
  createCookie(e, "", -1);
}
function getParameterByName(e, r) {
  r || (r = window.location.href), (e = e.replace(/[\[\]]/g, "\\$&"));
  var t = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(r);
  return t ? (t[2] ? decodeURIComponent(t[2].replace(/\+/g, " ")) : "") : null;
}
window.init_captchas = function () {
  if (-1 === document.location.href.indexOf("stesting.abstracta.us")) {
    if (document.getElementById("end_form_captcha")) {
      var e = grecaptcha.render("end_form_captcha", {
        sitekey: captcha_sitekey,
        callback: () => {
          $("#end_form_captcha").parent().find(".error-field").remove();
        }
      });
      end_form_captcha_id = e;
    }
    if (document.getElementById("newsletter_captcha")) {
      var r = grecaptcha.render("newsletter_captcha", {
        sitekey: captcha_sitekey2,
        size: "invisible",
        callback: submit_newsletter_form,
        badge: "inline"
      });
      newsletter_captcha_id = r;
    }
  }
}
$(document).on("change", "#cv-upload", function (e) {
  $(".input-file-progress-bar").hide();
  $(".error-pdf").hide(),
    $(".input-file-inner").removeClass("error"),
    $(".label-input").show();
  if ($(this)[0].files.length) {
    let r = $(this),
      t = r[0].files[0].size,
      a = t / 1048576;
    if (
      ((a = Math.round(a)),
        a > 10)
    )
      return (
        $(".error-pdf").show(),
        $(".input-file-inner").addClass("error"),
        $(".error-pdf").html("The file you are trying to upload exceeds 10MB"),
        !1
      );
    $(".error-pdf").hide(),
      $(".input-file-inner").removeClass("error"),
      $(".input-file-progress-bar").show(),
      $(".label-input").hide(),
      $(".input-file-inner").addClass("success"),
      $(".name-pdf").html(r.val().replace(/C:\\fakepath\\/i, ""));
  }
});

$(document).on("click", ".close", function () {
  $(".url").text(""), $(".url").addClass("hidden");
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("input[type=text]").forEach((e) =>
    e.addEventListener("keypress", (e) => {
      13 == e.keyCode && e.preventDefault();
    })
  );
  set_adwords_variables();
  initPhoneInput();
  initCountryInput();
});

(function loadReCaptcha() {
  const forms = document.getElementsByTagName('form');
  let injectTimeout;
  // trigger loading api.js (recaptcha.js) script
  let injectReCaptcha = () => {
    if (injectTimeout) clearTimeout(injectTimeout);
    if (!document.querySelector("script[src^=\"https://www.google.com/recaptcha/api.js\"]")) {
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://www.google.com/recaptcha/api.js?hl=en&onload=init_captchas&render=explicit';
      head.appendChild(script);
    } else {
      init_captchas();
    }
    for (let i = 0; i < forms.length; i++) {
      forms[i].removeEventListener('focus', injectReCaptcha, true)
    }
  };

  // add initial event listener to our basic HTML form
  for (let i = 0; i < forms.length; i++) {
    forms[i].addEventListener('focus', injectReCaptcha, { capture: true })
  }
  injectTimeout = setTimeout(injectReCaptcha, 10000)
})()